import { batch } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { activate, deactivate } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';
import { IActivateResponse } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/activate/dto/responseDto';
import { IDeactivateResponse } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/deactivate/dto/responseDto';
import { EOfferState } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { removeTransaction } from '~/src/features/payments-abn/store/actions';
import { specialOfferAnalytics } from '~/src/features/specialOffersContainer/analytics';
import {
    setErrorMessage,
    setIsPopupOpened,
    setOfferTransaction,
    setPopupState,
    setSelectedOfferId,
} from '~/src/features/specialOffersContainer/store/actions';
import { loadOffers, setOffer } from '~/src/features/specialOffersContainer/store/actions/thunk';
import { selectOffer } from '~/src/features/specialOffersContainer/store/selectors';
import { TAppThunkDispatch, TGetState } from '~/src/store';

export const updateOffer = () => async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
    const state = getState();
    const offer = selectOffer(state);

    if (!offer) {
        return;
    }

    const {
        id: offerId,
        state: currentStep,
        requestId,
    } = offer;
    const { isPopupOpened, transaction } = state.specOffers;

    const isDisconnectingAction = currentStep === EOfferState.CONNECTED;

    dispatch(setOffer({
        id: offerId,
        value: { ['isConnecting']: true },
    }));

    const response = await doRequest.specOffer<IActivateResponse | IDeactivateResponse>(
        isDisconnectingAction
            ? deactivate(offerId)
            : activate({
                specOfferId: offerId,
                currentStepId: currentStep,
                requestId,
            }),
    );

    dispatch(setOffer({
        id: offerId,
        value: { ['isConnecting']: false },
    }));

    if (!response.isSuccess) {
        specialOfferAnalytics.connectionError(offer);

        batch(() => {
            dispatch(setErrorMessage(response.error.message));
            dispatch(setIsPopupOpened(false));
            dispatch(setPopupState('connectionError'));
        });

        return;
    }

    isDisconnectingAction
        ? specialOfferAnalytics.successDisconnected(offer)
        : specialOfferAnalytics.successConnected(offer);

    const { currentStepId } =  response.payload;

    if (currentStepId !== EOfferState.DISCONNECTED) {
        dispatch(setOffer({
            id: offerId,
            value: { state: currentStepId },
        }));
    }

    if (isPopupOpened) {
        dispatch(setSelectedOfferId(requestId));
    }

    batch(() => {
        dispatch(setIsPopupOpened(false));
        dispatch(setPopupState('connected'));
        dispatch(setOfferTransaction(null));
        dispatch(removeTransaction(transaction ?? ''));
        dispatch(loadOffers(true));
    });
};
